import {
    CONFIRMED_GET_ROLES,
    CONFIRMED_ADD_ROLE,
    CONFIRMED_EDIT_ROLE,
    CONFIRMED_DELETE_ROLE,
    CONFIRMED_GET_MODULE_LIST,
    //GET_ROLES_REQUEST,
    //GET_ROLES_FAILURE,
  } from "./RoleType";
  
  import {
    getRoles,
    addOrUpdateRole,
    deleteRole,
    getModuleList,
    getRoleModules
  } from "../../services/RoleServices";
  
  import swal from "sweetalert";
import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Token util
  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
    const storedUser = localStorage.getItem("userDetails");
    return storedUser ? JSON.parse(storedUser).token : null;
  }
  
  // Get All Roles
  export function getRolesAction(search_by = "", search_keyword = "") {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const response = await getRoles(token,search_by,search_keyword);
  
        if (response?.status === 200 && response.data?.status === "success") {
          dispatch({
            type: CONFIRMED_GET_ROLES,
            payload: response.data.data,
          });
        } else {
          showErrorAlert("Failed to fetch roles");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert("Failed to fetch roles");
      }
    };
  }
  
  // Add or Update Role
  export function addOrUpdateRoleAction(roleData) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const response = await addOrUpdateRole(roleData, token);
  
        if (response?.status === 200 && response.data?.status === "success") {
          handleSuccess("Role saved successfully");
  
          const updatedRole = response.data.data;
          dispatch({
            type: roleData.role_id ? CONFIRMED_EDIT_ROLE : CONFIRMED_ADD_ROLE,
            payload: updatedRole,
          });
        } else {
          showErrorAlert(response.data?.message || "Failed to save role");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert("Failed to save role");
      }
    };
  }
  
  // Delete Role
  export function deleteRoleAction(roleId) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const response = await deleteRole({role_id: roleId},token);
  
        if (response?.status === 200 && response.data?.status === "success") {
          handleSuccess("Role deleted successfully");
          dispatch({
            type: CONFIRMED_DELETE_ROLE,
            payload: { role_id: roleId },
          });
        } else {
          showErrorAlert(response.data?.message || "Failed to delete role");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert("Failed to delete role");
      }
    };
  }
  

  export function getModuleListAction() {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const response = await getModuleList(token);
  
        if (response?.status === 200 && response.data?.status === "success") {
          dispatch({
            type: CONFIRMED_GET_MODULE_LIST,
            payload: response.data.data,
          });
        } else {
          showErrorAlert("Failed to fetch module list");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert("Failed to fetch module list");
      }
    };
  }

  export function getRolesWithModulesAction(pagination = true, pageid = 0, search_by = "", search_keyword = "" ,sort_by ="", sory_order) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const rolesResponse = await getRoles(pagination, pageid, search_by, search_keyword );
        const modulesResponse = await getRoleModules(pagination, pageid, search_by, search_keyword,sort_by,sory_order);
  
        if (
          rolesResponse?.status === 200 &&
          rolesResponse.data?.status === "success" &&
          modulesResponse?.status === 200 &&
          modulesResponse.data?.status === "success"
        ) {
          const roles = rolesResponse.data.data;
          const moduleList = modulesResponse.data.data;
  
          // Create map: { [module_id]: module_name }
          const moduleNameMap = moduleList.reduce((acc, module) => {
            acc[module.module_id] = module.module_name;
            return acc;
          }, {});
  
          // Add module_name in each module under each role
          const rolesWithModuleNames = roles.map((role) => ({
            ...role,
            modules: (role.modules || []).map((mod) => ({
              ...mod,
              module_name: moduleNameMap[mod.module_id] || "",
            })),
          }));
  
          dispatch({
            type: CONFIRMED_GET_ROLES,
            payload: rolesWithModuleNames,
          });
        } else {
          showErrorAlert("Failed to fetch roles or modules");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert("Failed to fetch roles or modules");
      }
    };
  }
  